@if(loadingDashboard) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Cargando Dashboard'"></app-loader>
  </div>
}

<!-- Password expiration dialog -->
<p-dialog header="Contraseña próxima a vencer" [(visible)]="showModalExpiration" [modal]="true" [style]="{width: '420px'}" [closable]="true">
  <div class="space-y-3">
    <div class="flex items-center gap-3">
      <i class="pi pi-exclamation-triangle text-2xl text-mustard-600"></i>
      <p class="text-sm text-vivid-royal-700 dark:text-dark-khaki-50">
        Estimado cliente, su contraseña está próxima a vencer. Te recomendamos actualizarla en este momento.
      </p>
    </div>
  </div>
  <ng-template #footer>
    <button pButton label="Después" class="p-button-text" (click)="showModalExpiration=false"></button>
    <button pButton label="Actualizar ahora" icon="pi pi-key" (click)="goToUpdate()"></button>
  </ng-template>
</p-dialog>

<!-- Card expiration alert dialog -->
<p-dialog header="Tarjetas próximas a vencer" [(visible)]="showCardExpirationAlert" [modal]="true" [style]="{width: '420px'}" [closable]="true">
  <div class="space-y-3">
    <div class="flex items-center gap-3">
      <i class="pi pi-credit-card text-2xl text-mustard-600"></i>
      <p class="text-sm text-vivid-royal-700 dark:text-dark-khaki-50">
        Tiene <strong>{{ expiringCardsCount }}</strong> tarjeta(s) vencida(s) o próxima(s) a vencer.
      </p>
    </div>
  </div>
  <ng-template #footer>
    <button pButton label="Después" class="p-button-text" (click)="showCardExpirationAlert=false"></button>
    <button pButton label="Ver detalle" icon="pi pi-eye" (click)="goToCardExpiration()"></button>
  </ng-template>
</p-dialog>

<div class="p-6" *ngIf="!loadingDashboard">

  <!-- Edit toolbar -->
  @if(editable) {
    <div class="flex items-center justify-center gap-3 py-4">
      <app-menu-panel [paneles]="paneles" (closeListener)="addItemToLayout($event)"></app-menu-panel>
      <button pButton icon="pi pi-times" label="Cancelar" class="p-button-sm p-button-outlined"
        (click)="editable=false"></button>
      <button pButton icon="pi pi-check" label="Guardar" class="p-button-sm"
        (click)="editable=false;saveDashboardLayout()"></button>
    </div>
  }

  <!-- Desktop grid -->
  <div class="hidden md:flex">
    <ktd-grid [cols]="cols" [rowHeight]="rowHeight" [layout]="layout" [scrollableParent]="document"
      [compactType]="compactType" [gap]="gap" compactOnPropsChange="true" (layoutUpdated)="onLayoutUpdated($event)"
      (gridItemResize)="onGridItemResize($event)">
      @for(item of paneles; track item; let i = $index) {
        <ktd-grid-item id="{{item.panelId}}" [draggable]="editable" [resizable]="editable" class="z-10 overflow-visible">
          <ng-template ktdGridItemPlaceholder>
            <div class="bg-vivid-royal-200/30 h-full w-full rounded-xl"></div>
          </ng-template>

          <!-- Remove button -->
          @if(editable && !item.hidden) {
            <div class="z-50 absolute top-2 left-2 w-7 h-7 rounded-full bg-red-500 shadow-sm flex items-center justify-center cursor-pointer text-white hover:bg-red-600 transition-colors"
              (mousedown)="stopEventPropagation($event)" (click)="removePanel(item)">
              <i class="pi pi-times text-xs"></i>
            </div>
          }

          <!-- KPI Card -->
          @if(!item.isChart && !item.isTable && !item.hidden) {
            <div class="w-full h-full p-5 rounded-xl shadow-sm bg-white dark:bg-crayola-blue-800 relative z-10 overflow-visible"
              [ngClass]="{'ring-2 ring-vivid-royal-300': editable}">
              <div class="flex flex-col items-center justify-center h-full">
                <img *ngIf="item.icon" src="./assets/icons/{{item.icon}}" class="w-16 mb-2" />
                <h2 class="text-2xl md:text-3xl font-bold text-vivid-royal-700 dark:text-white">
                  {{ item.isCurrency ? (item.value | currency) : item.value }}
                </h2>
                <p class="text-sm text-vivid-royal-400 dark:text-vivid-royal-200 mt-1">{{ item.title }}</p>
              </div>
            </div>
          }

          <!-- Chart Card -->
          @if(item.isChart && !item.isTable && !item.hidden) {
            <div class="w-full h-full p-5 rounded-xl shadow-sm bg-white dark:bg-crayola-blue-800 relative z-10 overflow-visible"
              [ngClass]="{'ring-2 ring-vivid-royal-300': editable}">
              <h3 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100 mb-3">{{ item.title }}</h3>
              <div class="h-[calc(100%-2rem)]">
                @if(item.type === 'line') {
                  <app-lineal-chart [id]="i.toString()" [datasets]="item.dataChart" [labels]="item.labelsChart"
                    [method]="item.webMethod" [clientNumber]="data.Client_number"></app-lineal-chart>
                } @else if(item.type === 'bar') {
                  <app-bar-chart [options]="chartOptions" [datasets]="item.dataChart" [labels]="item.labelsChart"
                    [displayLabel]="false" [method]="item.webMethod" [clientNumber]="data.Client_number"></app-bar-chart>
                }
              </div>
            </div>
          }

          <!-- Table Card -->
          @if(item.isTable && !item.isChart && !item.hidden) {
            <div class="w-full h-full p-5 rounded-xl shadow-sm bg-white dark:bg-crayola-blue-800 relative z-10 overflow-visible"
              [ngClass]="{'ring-2 ring-vivid-royal-300': editable}">
              <h3 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100 mb-3">{{ item.title }}</h3>
              <app-custom-table [headers]="item.headers" [elements]="item.items"
                [emptyTableMessage]="'No hay facturas por visualizar'"></app-custom-table>
            </div>
          }

          <!-- Edit overlay -->
          @if(editable && !item.hidden) {
            <div class="absolute z-40 inset-0 bg-vivid-royal-900/70 rounded-xl"></div>
          }

          <label ktdGridResizeHandle class="resize-handle-1 top-1/2 -right-2 absolute z-40 text-white">
            <i class="pi pi-arrows-h" *ngIf="editable && !item.hidden"></i>
          </label>
          <label ktdGridResizeHandle class="resize-handle-down-1 right-1/2 -bottom-2 absolute z-40 text-white">
            <i class="pi pi-arrows-v" *ngIf="editable && !item.hidden"></i>
          </label>
          <label ktdGridDragHandle class="handle-2 z-50 text-white absolute top-1/2 right-1/2">
            <i class="pi pi-arrows-alt" *ngIf="editable && !item.hidden"></i>
          </label>
        </ktd-grid-item>
      }
    </ktd-grid>
  </div>

  <!-- Mobile cards -->
  <div class="md:hidden grid grid-cols-1 gap-3">
    @for(item of paneles; track item; let i = $index) {
      @if(!item.isChart && !item.isTable && !item.hidden) {
        <div class="p-5 rounded-xl shadow-sm bg-white dark:bg-crayola-blue-800 text-center">
          <img *ngIf="item.icon" src="./assets/icons/{{item.icon}}" class="w-16 mx-auto mb-2" />
          <h2 class="text-2xl font-bold text-vivid-royal-700 dark:text-white">
            {{ item.isCurrency ? (item.value | currency) : item.value }}
          </h2>
          <p class="text-sm text-vivid-royal-400 dark:text-vivid-royal-200 mt-1">{{ item.title }}</p>
        </div>
      }
      @if(item.isChart && !item.isTable && !item.hidden) {
        <div class="p-5 rounded-xl shadow-sm bg-white dark:bg-crayola-blue-800">
          <h3 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100 mb-3">{{ item.title }}</h3>
          @if(item.type === 'line') {
            <app-lineal-chart [id]="i.toString()+'mob'" [datasets]="item.dataChart" [labels]="item.labelsChart"
              [method]="item.webMethod" [clientNumber]="data.Client_number"></app-lineal-chart>
          } @else if(item.type === 'bar') {
            <app-bar-chart [options]="chartOptions" [datasets]="item.dataChart" [labels]="item.labelsChart"
              [isDownloadable]="false" [displayLabel]="false" [method]="item.webMethod"
              [clientNumber]="data.Client_number"></app-bar-chart>
          }
        </div>
      }
      @if(item.isTable && !item.isChart && !item.hidden) {
        <div class="p-5 rounded-xl shadow-sm bg-white dark:bg-crayola-blue-800">
          <h3 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100 mb-3">{{ item.title }}</h3>
          <app-custom-table [headers]="item.headers" [elements]="item.items"
            [emptyTableMessage]="'No hay facturas por visualizar'"></app-custom-table>
        </div>
      }
    }
  </div>
</div>
